<template>
    <div class='main'>
        <div class='content'>
            <div class='content-header'>
                <span class='icon back' @click='$router.back()'><i class='fas fa-arrow-left' aria-hidden='true'></i></span>
                <h3>{{ schoolName }} / 年度一覧</h3>
                <button class='right-block button is-info' @click='changeActive'>新規追加</button>
            </div>
            <ul v-if='schoolMap[schoolId]' class='list'>
                <li v-for="(year, key) in schoolMap[schoolId].years" :key="key" :value="key" class='list-item' role="button" tabindex="0" @click='detail(key)' @keydown.enter.prevent='detail(key)' @keydown.space.prevent='detail(key)'>
                    <input type='text' :id='`enabled-${key}`' :value='year.name' @change='edit(key)' @click='onNameClick(key, $event)' disabled>
                    <div class='right-block'>
                        <span class='icon' @click.stop='enabled(key)'><i class='fas fa-pen' aria-hidden='true'></i></span>
                        <span class='icon' @click.stop='trash(key)'><i class='fas fa-trash' aria-hidden='true'></i></span>
                    </div>
                </li>
            </ul>
        </div>

        <div class="modal" :class="{ 'is-active': isActive }">
            <div class="modal-background" @click='changeActive'></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">年度新規追加</p>
                    <button class="delete" aria-label="close" @click='changeActive'></button>
                </header>
                <section class="modal-card-body">
                    <input class="input" type="text" v-model='yearName' placeholder="年度名">
                </section>
                <footer class="modal-card-foot">
                    <div class='right-block'>
                        <button class="button is-info" @click='add'>送信</button>
                        <button class="button" @click='changeActive'>閉じる</button>
                    </div>
                </footer>
            </div>
            <button class="modal-close is-large" aria-label="close" @click='changeActive'></button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'School',
    props: ['schoolMap'],
    components: {
    },
    data () {
        return {
            setting: false,
            upload: true,
            isActive: false,
            schoolName: '',
            yearName: '',
            schoolId: null
        }
    },
    mounted () {
        this.schoolId = this.$route.params.schoolId
        if (this.schoolMap[this.schoolId]) this.schoolName = this.schoolMap[this.schoolId].name
    },
    watch: {
        schoolMap: {
            handler () {
                if (this.schoolMap[this.schoolId]) this.schoolName = this.schoolMap[this.schoolId].name
            },
            deep: true
        }
    },
    methods: {
        changeActive () {
            this.isActive = !this.isActive
        },
        trash (key) {
            if (window.confirm('削除した年度にアップロードされた全ての写真、行事データは削除されますがよろしいですか？')) {
                this.axios.delete(`${process.env.API_URL}/photographer/year/${key}`).then((res) => {
                    location.reload()
                }).catch((e) => {
                    alert('サーバーエラーが発生しました')
                })
            }
        },
        edit (key, e) {
            document.getElementById(`enabled-${key}`).disabled = true
            this.axios.put(`${process.env.API_URL}/photographer/year`, {
                id: key,
                name: document.getElementById(`enabled-${key}`).value
            }).then((res) => {
                console.log(res)
            }).catch((e) => {
                alert('サーバーエラーが発生しました')
            })
        },
        add () {
            const params = this.$parent.requestParams
            this.axios.post(`${process.env.API_URL}/photographer/year${params}`, {
                name: this.yearName,
                school_id: this.schoolId
            }).then((res) => {
                location.reload()
            }).catch((e) => {
                alert('サーバーエラーが発生しました')
            })
        },
        detail (key, e) {
            const params = this.$parent.requestParams
            this.$router.push(this.$route.path + `/${key}${params}`)
        },
        enabled (key) {
            document.getElementById(`enabled-${key}`).disabled = !document.getElementById(`enabled-${key}`).disabled
        },
        onNameClick (key, event) {
            const input = document.getElementById(`enabled-${key}`)
            if (input && !input.disabled) {
                event.stopPropagation()
            }
        }
    }
}
</script>

<style scoped>

.tabs {
    width: calc(100vw - 200px);
}
.content {
    margin: auto;
    padding: 25px;
    width: 780px;
}

.list {
}

.list-item {
    height: 48px;
    padding: 4px 12px;
    list-style: none;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    cursor: pointer;
    align-items: center;
}

.list-item:hover {
    background: rgba(31, 122, 224, 0.08);
}

.list-item:hover input:disabled {
    background: transparent;
    color: #222;
    cursor: pointer;
}

.list-item:focus {
    outline: 2px solid rgba(31, 122, 224, 0.4);
    outline-offset: 2px;
}

.list-item input {
    height: 40px;
    font-size: 18px;
    line-height: 40px;
    padding: 0 8px;
}

.list-item input:disabled {
    background: white;
    border: none;
    height: 40px;
    font-size: 18px;
    pointer-events: none;
}

.right-block {
    margin-left: auto;
    display: flex;
    align-items: center;
}

.icon {
    cursor: pointer;
    font-size: 22px;
    padding: 8px 10px;
}

.icon + .icon {
    margin-left: 10px;
}

.content-header {
    display: flex;
    padding-bottom: 20px;
}

.content-header h3 {
    line-height: 40px;
    margin: 0;
    margin-top: 0;
}

.back {
    height: 40px;
    width: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/photographer/pages/Year.vue